/**
 * Verifica se um serviço tem preços ou durações personalizados ativos
 * @param {Object} professionalCustomizations - Objeto com customizações por profissional
 * @returns {boolean} - Retorna true se houver pelo menos um profissional com valores personalizados ativos
 */
export const hasActiveCustomizations = (professionalCustomizations) => {
  if (!professionalCustomizations) return false;
  
  return Object.values(professionalCustomizations).some(customization => {
    return (
      // Verificar se há valores customizados não nulos
      (customization.customPrice !== null && customization.customPrice !== undefined) ||
      (customization.customDuration !== null && customization.customDuration !== undefined)
    );
  });
};

/**
 * Obtém o preço personalizado de um serviço para um profissional específico
 * @param {Object} service - Objeto do serviço
 * @param {string} professionalId - ID do profissional
 * @returns {number|null} - Preço personalizado ou null se não existir
 */
export const getCustomPriceForProfessional = (service, professionalId) => {
  if (!service?.professionalCustomizations?.[professionalId]) return null;
  
  const customization = service.professionalCustomizations[professionalId];
  return customization.customPrice !== null && customization.customPrice !== undefined
    ? customization.customPrice
    : null;
};

/**
 * Obtém a duração personalizada de um serviço para um profissional específico
 * @param {Object} service - Objeto do serviço
 * @param {string} professionalId - ID do profissional
 * @returns {number|null} - Duração personalizada ou null se não existir
 */
export const getCustomDurationForProfessional = (service, professionalId) => {
  if (!service?.professionalCustomizations?.[professionalId]) return null;
  
  const customization = service.professionalCustomizations[professionalId];
  return customization.customDuration !== null && customization.customDuration !== undefined
    ? customization.customDuration
    : null;
}; 